module.exports = {
    DEBUG: false,
    API_HOST: 'http://localhost:8000/api',
    API_VERSION: '/v2',
}
